module.exports = __webpack_public_path__ + "static/escola-fddf7668f37f26726177884dc0e1eea3.jpg";